import * as types from "../types";

// 通用配置
const state = {
  openId: "",
  userId: "",
  goindex:0, //路由长度
  cityId: '',
  isChange: false,
  flag: false, // 是否加载完初始数据
  uploadDirection: "forward", // 默认向前
  marketInfo: {
    cityId: "",
    cityName: "",
    createTime: 1567583151000,
    id: "",
    isDrop: '',
    isOpen: '',
    isPushMeeting: '',
    marketName: "",
    marketType: '',
    styleType: 0,
    updateTime: 1567583151000
  },
  marketList: [],
  theme: 0,
  holidayStyle: 1, //节假日主题
  userInfo: {}, // 用户信息
  userTenantInfo: {}, //默认认证企业
  userTenantInfoList: [], //认证企业列表
  ziDianData: [], //字典
  meetingUseTime: 0, //会议室使用次数
  visitedNum: 0, //访客数据
  teamReport: {}, //员工人员统计
  activeList: [], //活动列表
  wallList: [], //企业墙列表
  myHeaderDate: {}, //我的页面头部数据
  hasTsModule: false //是否有投诉建议模块(同创项目把投诉建议功能隐藏,放到物业报修里面)
};

const actions = {
  getOpenId({
    commit
  }, res) {
    commit(types.GET_OPENID, res);
  },
  setCityId({
    commit
  }, res) {
    commit(types.SET_CITYID, res);
  },
  getTheme({
    commit
  }, res) {
    commit(types.GET_THEME, res);
  },
  getGoindex({
    commit
  }, res) {
    commit(types.GET_goindex, res);
  },
  getHolidayStyle({
    commit
  }, res) {
    commit(types.GET_HolidayStyle, res);
  },
  getUserId({
    commit
  }, res) {
    commit(types.GET_USERID, res);
  },
  getMarketInfo({
    commit
  }, res) {
    commit(types.GET_MARKETINFO, res);
  },
  getMarketList({
    commit
  }, res) {
    commit(types.GET_MARKETLIST, res);
  },
  getUserInfo({
    commit
  }, res) {
    commit(types.GET_USERINFOR, res);
  },
  getFlag({
    commit
  }, res) {
    commit(types.GET_FLAG, res);
  },
  changeSomeInfo({
    commit
  }, res) {
    commit("changeSomeInfoData", res);
  },
  getTenantInfo({
    commit
  }, res) {
    commit(types.GET_USERTENANTINFO, res);
  },
  getTenantInfoList({
    commit
  }, res) {
    commit(types.GET_USERTENANTINFOLIST, res);
  },
  getZiDianData({
    commit
  }, res) {
    commit("ziDianData", res);
  },
  getmeetingUseTime({
    commit
  }, res) {
    commit(types.MEETINGUSETIME, res);
  },
  getTeamReport({
    commit
  }, res) {
    commit(types.GETTEAMREPORT, res);
  },
  getActiveList({
    commit
  }, res) {
    commit(types.GETACTIVELIST, res)
  },
  getWallList({
    commit
  }, res) {
    commit(types.GETWALLLIST, res)
  },
  getMyHeaderDate({
    commit
  }, res) {
    commit(types.MYHEADERDATE, res)
  }
};
const mutations = {
  [types.GET_THEME](state, val) {
    state.theme = val;
  },
  [types.GET_goindex](state, val) {
    state.goindex = val;
  },
  [types.GET_HolidayStyle](state, val) {
    state.holidayStyle = val;
  },

  [types.GET_OPENID](state, val) {
    state.openId = val;
  },
  [types.SET_CITYID](state, val) {
    state.cityId = val;
  },
  [types.GET_USERID](state, val) {
    state.userId = val;
  },
  [types.GET_MARKETINFO](state, val) {
    state.marketInfo = val;
  },
  [types.GET_MARKETLIST](state, val) {
    let obj = {};
    let newA = [];
    val.forEach((item) => {
      if (!obj[item.frameworkName]) {
        obj[item.frameworkName] = true;
        newA.push({
          frameworkName: item.frameworkName,
          cityMarkets: [item],
        });
      } else {
        newA.forEach((cur) => {
          if (cur.frameworkName == item.frameworkName) {
            cur.cityMarkets.push(item);
          }
        });
      }
    });
    state.marketList = newA;
  },
  [types.GET_USERINFOR](state, val) {
    state.userInfo = val;
  },
  changeSomeInfoData(state, val) {
    state.userInfo[val.name] = val.val;
  },
  [types.GET_USERTENANTINFO](state, val) {
    state.userTenantInfo = val;
  },
  [types.GET_USERTENANTINFOLIST](state, val) {
    state.userTenantInfoList = val;
  },
  [types.UPDATE_DIRECTION](state, val) {
    state.uploadDirection = val;
  },
  [types.GET_FLAG](state, val) {
    state.flag = val;
  },
  isChange(state, val) {
    state.isChange = val;
  },
  ziDianData(state, val) {
    state.ziDianData = val;
  },
  [types.MEETINGUSETIME](state, val) {
    state.meetingUseTime = val;
  },
  [types.GETTEAMREPORT](state, val) {
    state.teamReport = val;
  },
  [types.GETACTIVELIST](state, val) {
    state.activeList = val;
  },
  [types.GETWALLLIST](state, val) {
    state.wallList = val;
  },
  [types.MYHEADERDATE](state, val) {
    state.myHeaderDate = val;
  },
  [types.HASTSMODULE](state, val) {
    state.hasTsModule = val;
  },
};
export default {
  state,
  actions,
  mutations
};